<bl-modal-content
  #content
  [title]="'出力条件'"
  [okButtonSetting]="okButtonSetting"
  [footerButtonType]="footerButtonType"
>
  <div class="pattern-modal-contents" body dnd-sortable>
    <div class="basic-condition-area">
      <div class="row">
        <div class="col-md-12 col-xs-12 col-lg-12">
          <div class="p-vo-detailed__contents__modalinput">
            <span class="select-label">残高種別</span>
            <span>:</span>
            <bl-select
              #balanceType
              [items]="balanceTypeItems"
              [(value)]="condition.balanceType"
            ></bl-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12 col-lg-12">
          <div class="p-vo-detailed__contents__modalinput">
            <span class="select-label">抽出拠点</span>
            <span>:</span>
            <bl-select
              [items]="extractionOrganizationDivItems"
              [(value)]="condition.extractionOrganizationDiv"
            ></bl-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12 col-lg-12">
          <div class="p-vo-detailed__contents__modalinput">
            <span>拠点</span>
            <span class="colon">:</span>
            <bl-code-input
              [(value)]="condition.organizationCodeStart"
              [option]="{enableBlank: true, valueProperty:'organizationCode', valueGuideProperty:'organizationCode'}"
              [maxlength]="6"
              [align]="'left'"
              [resource]="organizationResource"
            ></bl-code-input>
            <span class="input-group-btn">
              <button
                class="btn btn-default btn-sm"
                (click)="onShowGuide('organizationCodeStart')"
              >
                <span class="icon-icon_guide"></span>
              </button>
            </span>
            <span class="form-content__range">～</span>
            <bl-code-input
              [(value)]="condition.organizationCodeEnd"
              [option]="{enableBlank: true, valueProperty:'organizationCode', valueGuideProperty:'organizationCode'}"
              [maxlength]="6"
              [align]="'left'"
              [resource]="organizationResource"
            ></bl-code-input>
            <span class="input-group-btn">
              <button
                class="btn btn-default btn-sm"
                (click)="onShowGuide('organizationCodeEnd')"
              >
                <span class="icon-icon_guide"></span>
              </button>
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12 col-lg-12">
          <div class="p-vo-detailed__contents__modalinput">
            <span>得意先</span>
            <span class="colon">:</span>
            <bl-code-input
              [(value)]="condition.customerCodeStart"
              [option]="{enableBlank: true, valueProperty:'customerCode', valueGuideProperty:'customerCode'}"
              [maxlength]="9"
              [align]="'left'"
              [resource]="customerResource"
            ></bl-code-input>
            <span class="input-group-btn">
              <button
                class="btn btn-default btn-sm"
                (click)="onShowGuide('customerCodeStart')"
              >
                <span class="icon-icon_guide"></span>
              </button>
            </span>
            <span class="form-content__range">～</span>
            <bl-code-input
              [(value)]="condition.customerCodeEnd"
              [option]="{enableBlank: true, valueProperty:'customerCode', valueGuideProperty:'customerCode'}"
              [maxlength]="9"
              [align]="'left'"
              [resource]="customerResource"
            ></bl-code-input>
            <span class="input-group-btn">
              <button
                class="btn btn-default btn-sm"
                (click)="onShowGuide('customerCodeEnd')"
              >
                <span class="icon-icon_guide"></span>
              </button>
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12 col-lg-12">
          <div class="p-vo-detailed__contents__modalinput">
            <span>対象年月</span>
            <span class="colon">:</span>
            <div class="form-item__date">
              <bl-date
                [era]="Era.Ad"
                [(value)]="condition.targetYearMonthStart"
                [dateMode]="DateMode.Month"
              ></bl-date>
            </div>
            <span class="form-content__range">～</span>
            <div class="form-item__date">
              <bl-date
                [era]="Era.Ad"
                [(value)]="condition.targetYearMonthEnd"
                [dateMode]="DateMode.Month"
              ></bl-date>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12 col-lg-12">
          <div class="p-vo-detailed__contents__modalinput">
            <span>与信残高の出力</span>
            <span class="colon">:</span>
            <bl-checkbox
              [label]="'出力する'"
              [checked]="condition.creditBalanceOutputFlag"
              (changeEvent)="onChangeCheckboxEvent($event, 'creditBalanceOutputFlag')">
            </bl-checkbox>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12 col-lg-12">
          <div class="p-vo-detailed__contents__modalinput">
            <span>実績の無いデータの出力</span>
            <span class="colon">:</span>
            <bl-checkbox
              [label]="'出力する'"
              [checked]="condition.actualNoneOutputFlag"
              (changeEvent)="onChangeCheckboxEvent($event, 'actualNoneOutputFlag')">
            </bl-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/feature/export-modal/credit-export-condition-modal/credit-export-condition-modal.component.html